import api from './api';

export interface Category {
  id: string;
  name: string;
  displayName: string;
  isActive: boolean;
  displayOrder: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCategoryRequest {
  name: string;
  displayName: string;
  displayOrder?: number;
}

export interface UpdateCategoryRequest {
  displayName?: string;
  displayOrder?: number;
  isActive?: boolean;
}

export const categoryService = {
  // Get all categories
  async getCategories(): Promise<Category[]> {
    const response = await api.get('/categories');
    return response.data.data;
  },

  // Get single category
  async getCategory(id: string): Promise<Category> {
    const response = await api.get(`/categories/${id}`);
    return response.data.data;
  },

  // Create category
  async createCategory(category: CreateCategoryRequest): Promise<Category> {
    const response = await api.post('/categories', category);
    return response.data.data;
  },

  // Update category
  async updateCategory(id: string, updates: UpdateCategoryRequest): Promise<Category> {
    const response = await api.put(`/categories/${id}`, updates);
    return response.data.data;
  },

  // Delete category
  async deleteCategory(id: string): Promise<void> {
    await api.delete(`/categories/${id}`);
  },

  // Bulk update display order
  async reorderCategories(orders: { id: string; displayOrder: number }[]): Promise<void> {
    await api.put('/categories/reorder', { orders });
  },
};